<template>
	<b-button-group v-if="text === false">
		<b-button :variant="onVariant" @click="setValue(true)" :disabled="disabled">{{on}}</b-button>
		<b-button :variant="offVariant" @click="setValue(false)" :disabled="disabled">{{off}}</b-button>
	</b-button-group>
	<span v-else>{{textValue}}</span>
</template>
<script>

export default {
  name: 'toggle',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: 'On'
    },
    off: {
      type: String,
      default: 'Off'
    },
    variant: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    localValue: this.value
  }),
  computed: {
    onVariant () {
      return this.value ? this.variant : 'outline-primary'
    },
    offVariant () {
      return this.value ? 'outline-primary' : this.variant
    },
    textValue () {
      return this.value ? this.on : this.off
    }
  },
  methods: {
    setValue (value) {
      this.localValue = value
      this.$emit('input', this.localValue)
      this.$emit('change', this.localValue)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// ToggleButton.vue?6008eace